import get from 'lodash/get';
import { joinSplitSeoUrl } from '@atc/join-split-seo-url';
export default function getData(listing, searchLocation, baseUrl) {
  if (listing === void 0) {
    listing = {};
  }
  const {
    features,
    fuelType,
    id,
    images,
    make,
    model,
    owner,
    priceValidUntil,
    pricingDetail,
    quickViewFeatures,
    specifications,
    style,
    title,
    type,
    vin,
    year
  } = listing;
  let url = '';
  let options = '';
  const salePrice = get(pricingDetail, 'incentive', false) || get(pricingDetail, 'salePrice', false);
  const msrpPrice = get(pricingDetail, 'msrp', '0');
  const price = salePrice && salePrice !== 0 ? salePrice : msrpPrice;
  if (baseUrl) {
    url = baseUrl + 'cars-for-sale/vehicle/' + id;
  } else {
    url = joinSplitSeoUrl({
      protocol: 'https://',
      host: ['www', 'fordblueadvantage', 'com'],
      pathname: ['cars-for-sale', 'vehicle', id]
    });
  }
  if (features) {
    for (let i = 0; i < features.length; i += 1) {
      options = options + ', ' + features[i];
      if (options.length > 140) {
        break;
      }
    }
    options = ' includes' + options.slice(1);
  } else {
    options = ' is listed for $' + price;
  }
  const location = get(owner, 'location.address.city') ? get(owner, 'location.address.city', '') + ', ' + get(owner, 'location.address.state', '') : searchLocation;
  const listingQuickViewFeatures = Array.isArray(quickViewFeatures) ? `, ${quickViewFeatures.join(', ')}` : '';
  const vehicleDescription = 'Location: ' + location + '. This ' + year + ' ' + (make?.name ?? '') + ' ' + (model?.name ?? '') + options + listingQuickViewFeatures;
  return {
    '@context': 'http://schema.org/',
    '@type': 'Car',
    vehicleIdentificationNumber: vin,
    name: title,
    mpn: title,
    image: get(images, 'sources[0].src', ''),
    offers: {
      '@type': 'Offer',
      priceCurrency: 'USD',
      price,
      priceValidUntil,
      itemCondition: `http://schema.org/${type}Condition`,
      availability: 'http://schema.org/InStock',
      url,
      seller: {
        '@context': 'http://schema.org/',
        '@type': 'AutoDealer',
        name: get(owner, 'name', ''),
        telephone: get(owner, 'phone.value', ''),
        address: {
          '@context': 'http://schema.org/',
          '@type': 'PostalAddress',
          addressLocality: get(owner, 'location.address.city', ''),
          addressRegion: get(owner, 'location.address.state', ''),
          postalCode: get(owner, 'location.address.zip', ''),
          streetAddress: get(owner, 'location.address.address1', '')
        }
      }
    },
    brand: {
      '@context': 'http://schema.org/',
      '@type': 'Brand',
      name: make?.name
    },
    model: model?.name,
    manufacturer: {
      '@context': 'http://schema.org/',
      '@type': 'Organization',
      name: make?.name
    },
    productionDate: year,
    driveWheelConfiguration: get(specifications, 'driveType.value', ''),
    vehicleEngine: get(specifications, 'engine.value', ''),
    vehicleTransmission: get(specifications, 'transmission.value', ''),
    color: get(specifications, 'color.value', ''),
    mileageFromOdometer: {
      '@type': 'QuantitativeValue',
      value: get(specifications, 'mileage.value', '')
    },
    bodyType: style,
    url,
    vehicleInteriorColor: get(specifications, 'interiorColor.value', ''),
    fuelEfficiency: get(specifications, 'mpg.value', ''),
    fuelType: fuelType?.name,
    sku: id,
    description: vehicleDescription
  };
}